export enum ProfileUserRole {
  SuperAdmin = 1,
  Regular = 2,
  GodMode = 3
}
